// import React from 'react';
// import { ChevronRight, Home } from 'lucide-react';

// const Breadcrumb = ({ items, onNavigate }) => {
//   return (
//     <nav className="flex items-center space-x-2 text-sm mb-6" style={{fontFamily: 'Lexend, sans-serif'}}>
//       {items.map((item, index) => (
//         <div key={index} className="flex items-center">
//           {index > 0 && (
//             <ChevronRight className="h-4 w-4 text-[#808080] mx-2" />
//           )}
          
//           {item.href ? (
//             <button
//               onClick={() => onNavigate(item.href)}
//               className="text-[#B8B8B8] hover:text-[#676DFF] transition-colors cursor-pointer"
//               style={{fontFamily: 'Lexend, sans-serif'}}
//             >
//               {item.label}
//             </button>
//           ) : (
//             <span className="text-white font-medium" style={{fontFamily: 'Lexend, sans-serif'}}>
//               {item.label}
//             </span>
//           )}
//         </div>
//       ))}
//     </nav>
//   );
// };

// export default Breadcrumb;

import React, { useState, useEffect } from 'react';
import { ChevronRight, Home, ArrowLeft } from 'lucide-react';

const Breadcrumb = ({ items, onNavigate }) => {
  const [isMobile, setIsMobile] = useState(false);

  // Mobile detection hook
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Mobile: Show only back button and current page
  if (isMobile && items.length > 1) {
    const currentItem = items[items.length - 1];
    const previousItem = items[items.length - 2];
    
    return (
      <nav className="flex items-center justify-between mb-4 sm:mb-6 px-4 sm:px-0" style={{fontFamily: 'Lexend, sans-serif'}}>
        <button
          onClick={() => onNavigate(previousItem.href)}
          className="flex items-center space-x-2 text-[#B8B8B8] hover:text-[#676DFF] transition-colors duration-200 bg-[#151515]/60 hover:bg-[#151515]/80 px-3 py-2 rounded-lg border border-[#676DFF]/20 hover:border-[#676DFF]/40"
          style={{fontFamily: 'Lexend, sans-serif'}}
        >
          <ArrowLeft className="h-4 w-4" />
          <span className="text-sm font-medium">Back</span>
        </button>
        
        <div className="flex-1 text-center">
          <h1 className="text-lg font-semibold text-white truncate max-w-[200px] mx-auto" style={{fontFamily: 'Lexend, sans-serif'}}>
            {currentItem.label}
          </h1>
        </div>
        
        {/* Spacer to balance the layout */}
        <div className="w-[72px]"></div>
      </nav>
    );
  }

  // Desktop: Show full breadcrumb trail
  return (
    <nav className="flex items-center space-x-1 sm:space-x-2 text-sm mb-4 sm:mb-6 px-4 sm:px-0 overflow-x-auto scrollbar-hide" style={{fontFamily: 'Lexend, sans-serif'}}>
      <div className="flex items-center space-x-1 sm:space-x-2 min-w-max">
        {items.map((item, index) => (
          <div key={index} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 text-[#808080] mx-1 sm:mx-2 flex-shrink-0" />
            )}
            
            {item.href ? (
              <button
                onClick={() => onNavigate(item.href)}
                className="text-[#B8B8B8] hover:text-[#676DFF] transition-colors cursor-pointer whitespace-nowrap text-xs sm:text-sm font-medium px-2 py-1 rounded-md hover:bg-[#676DFF]/10"
                style={{fontFamily: 'Lexend, sans-serif'}}
              >
                {index === 0 && isMobile ? (
                  <Home className="h-4 w-4" />
                ) : (
                  item.label
                )}
              </button>
            ) : (
              <span className="text-white font-semibold whitespace-nowrap text-xs sm:text-sm px-2 py-1 bg-[#676DFF]/10 rounded-md border border-[#676DFF]/20" style={{fontFamily: 'Lexend, sans-serif'}}>
                {item.label}
              </span>
            )}
          </div>
        ))}
      </div>
      
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </nav>
  );
};

export default Breadcrumb;